import { createReducer, on } from '@ngrx/store';
import { PipelineRunSlice } from '../app-state';
import { initialPipelineRunSlice } from '../initial-slices';
import {
  deletePipelineRunSuccessful,
  setPipelineRunsForPipeline,
  setPipelineRunsForPipelineReleaseView,
  setSelectedPipelineRun,
  setSelectedPipelineRunForPipelineReleaseView,
  setSelectedPipelineRunOnlyInStore,
} from './pipeline-run.actions';

export const pipelineRunReducer = createReducer(
  initialPipelineRunSlice,
  on(setPipelineRunsForPipeline, (state, props): PipelineRunSlice => {
    const pipelineRunsState = { ...state.pipelineRuns };
    pipelineRunsState[props.pipelineId] = props.pipelineRuns;
    return { ...state, pipelineRuns: pipelineRunsState };
  }),
  on(setSelectedPipelineRun, setSelectedPipelineRunOnlyInStore, (state, props): PipelineRunSlice => {
    const selectedPipelineRunState = { ...state.selectedPipelineRun };
    selectedPipelineRunState[props.pipelineId] = props.selectedPipelineRunId;
    return { ...state, selectedPipelineRun: selectedPipelineRunState };
  }),
  on(deletePipelineRunSuccessful, (state, props): PipelineRunSlice => {
    const pipelineRunsState = { ...state.pipelineRuns };
    const pipelineId = props.pipelineId;
    const pipelineRunId = props.pipelineRunId;
    pipelineRunsState[pipelineId] = pipelineRunsState[pipelineId].filter((pipelineRun) => pipelineRun.id !== pipelineRunId);
    // note: we do not manipulate selectedPipelineRun here, as it is handled in the effects
    return { ...state, pipelineRuns: pipelineRunsState };
  }),
  on(setPipelineRunsForPipelineReleaseView, (state, props): PipelineRunSlice => {
    const pipelineRunsState = { ...state.pipelineRuns };
    pipelineRunsState[props.pipelineId] = props.pipelineRuns;
    return { ...state, pipelineRuns: pipelineRunsState };
  }),
  on(setSelectedPipelineRunForPipelineReleaseView, (state, props): PipelineRunSlice => {
    const selectedPipelineRunState = { ...state.selectedPipelineRun };
    selectedPipelineRunState[props.pipelineId] = props.selectedPipelineRunId;
    return { ...state, selectedPipelineRun: selectedPipelineRunState };
  }),
);
